"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLoader = exports.Loader = exports.LoaderContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var PIXI = _interopRequireWildcard(require("pixi.js"));

var _hooks = require("./hooks");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var LoaderContext = (0, _react.createContext)(PIXI.Loader.shared);
exports.LoaderContext = LoaderContext;
LoaderContext.displayName = 'Loader';

var Loader = function Loader(_ref) {
  var children = _ref.children,
      baseUrl = _ref.baseUrl,
      concurrency = _ref.concurrency;
  var loader = (0, _hooks.useCloseable)(function () {
    return new PIXI.Loader(baseUrl, concurrency);
  });
  if (baseUrl != null && baseUrl !== loader.baseUrl) loader.baseUrl = baseUrl;
  if (concurrency != null && concurrency !== loader.concurrency) loader.concurrency = concurrency;
  return _react.default.createElement(LoaderContext.Provider, {
    value: loader
  }, children);
};

exports.Loader = Loader;

Loader.Creator = function (_ref2) {
  var baseUrl = _ref2.baseUrl,
      concurrency = _ref2.concurrency;
  return (0, _react.useMemo)(function () {
    return {
      create: function create() {
        return new PIXI.Loader(baseUrl, concurrency);
      }
    };
  }, []);
};

var useLoader = function useLoader() {
  var loader = (0, _react.useContext)(LoaderContext);
  (0, _react.useDebugValue)(loader.progress, function (progress) {
    return "progress: ".concat(progress);
  });
  return loader;
};

exports.useLoader = useLoader;